import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { SubjectService } from '../../../../../services/subject/subject.service';
import { Subject } from '../../../../../models/subjects/subject';
import { CurriculumService } from '../../../../../services/curricula/curriculum.service';
import { AddEditSubjectCourseComponent } from '../add-edit-subject-course/add-edit-subject-course.component';
import { CourseYearsDataDto, CurriculumDataDto, SubjectDataDto } from '../../../../../models/curricula/dto/curriculum-data';
import { AddEditCourseYearComponent } from '../add-edit-course-year/add-edit-course-year.component';
import { CourseYearService } from '../../../../../services/cour-years/course-year.service';
import { Curriculum } from '../../../../../models/curricula/curriculum';
import { Md5 } from 'ts-md5';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-add-edit-curriculum',
    templateUrl: './add-edit-curriculum.component.html',
    styleUrls: ['./add-edit-curriculum.component.scss'],
    animations: fuseAnimations
})
export class AddEditCurriculumComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUIList: NgBlockUI;
    confirmDialogRef: any;
    curriculumId = -1;
    courseYearFormGroup;
    anioFormControl;
    public data: any;
    public subjects: Subject[] = [];
    public curriculum: CurriculumDataDto = new CurriculumDataDto();
    private sub: any;
    private md5Original: any;

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private location: Location,
                private router: Router,
                private route: ActivatedRoute,
                private fb: FormBuilder,
                private translationService: TranslationService,
                private subjectService: SubjectService,
                private curriculumService: CurriculumService,
                private courseYearService: CourseYearService,
                private translateService: TranslateService,
                private sweetAlertService: SweetAlertService) {
        this.initializeFormControlValidators();
        console.log('CurriculumDataDto>>>>>>>', this.curriculum);
    }

    initializeFormControlValidators() {
        this.courseYearFormGroup = this.fb.group({
            anioFormControl: ['', [Validators.required]]
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    ngOnInit(): void {
        this.blockUIList.start('Cargando datos...');
        this.data = this.route.snapshot.data;
        this.sub = this.route.params.subscribe(params => {
            this.curriculumId = params['id'] ? +params['id'] : -1;
        });
        console.log('this.curriculumId>>>>', this.curriculumId);
        this.loadData();
        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    disable() {
        this.courseYearFormGroup.get('anioFormControl').disable();
    }

    public loadData() {
        Observable.combineLatest(
            this.subjectService.getAll(),
            this.curriculumService.getAllYearSubject(this.curriculumId),
            this.courseYearService.getAll()
        ).subscribe(([subjects, curriculum, courseYears]) => {
            this.subjects = subjects;
            console.log('courseYears>>>>', courseYears);
            console.log('curriculum>>>>', curriculum);
            if (curriculum) {
                this.curriculum = curriculum;
            }
            courseYears.forEach(e => {
                if (!this.curriculum.CourseYears.find(c => c.Id === e.Id)) {
                    const course = new CourseYearsDataDto();
                    course.Id = e.Id;
                    course.CourseYearName = e.CourseYearName;
                    course.CourseYearSubjects = [];
                    this.curriculum.CourseYears.push(course);
                }
            });
            const md5 = new Md5();
            this.md5Original = md5.appendStr(JSON.stringify(this.curriculum)).end();

            this.blockUIList.stop();
        });

    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    addYear() {
        const config: MatDialogConfig = {
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                courseYear: new CourseYearsDataDto()
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditCourseYearComponent, config);

        this.confirmDialogRef.afterClosed().subscribe((result) => {
            if (result !== true) {
                this.curriculum.CourseYears.push(result);
            }
        });
    }

    back() {
        if (this.data.mode === 'view') {
            this.location.back();
        } else {
            const md5 = new Md5();
            const temp = md5.appendStr(JSON.stringify(this.curriculum)).end();
            if (temp !== this.md5Original) {
                this.sweetAlertService
                    .question('Error', 'Hay cambios sin guardar. ¿Desea Salir sin guardar los cambios?', 'Si', 'No', () => {
                        this.location.back();
                    });
                return;
            } else {
                this.location.back();
            }
        }
    }

    save() {
        this.blockUIList.start('Guardando datos...');
        this.curriculumService.add(this.curriculum).subscribe(response => {
            this.curriculum.Id = response.Id;
            this.curriculumId = response.Id;
            const curriculum = new Curriculum(this.curriculumId, this.curriculum.Description, true);
            const index = this.curriculumService.curricula.findIndex(st => st.Id === this.curriculumId);
            if (index === -1) {
                this.curriculumService.curricula.push(curriculum);
                this.curriculumService.curriculumObject[this.curriculumId] = curriculum;
            } else {
                this.curriculumService.curricula[index] = curriculum;
                this.curriculumService.curriculumObject[this.curriculumId] = curriculum;
            }
            const md5 = new Md5();
            this.md5Original = md5.appendStr(JSON.stringify(this.curriculum)).end();

            this.translateService.get('LABELS.DATA_SAVED_CORRECTLY').subscribe(res => {
                this.sweetAlertService.success('', res);
            });
            this.blockUIList.stop();
        }, error => {
            this.blockUIList.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    addSubject(courseYear: CourseYearsDataDto) {
        const config: MatDialogConfig = {
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                subject: new SubjectDataDto(),
                subjects: this.subjects
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditSubjectCourseComponent, config);

        this.confirmDialogRef.afterClosed().subscribe((result) => {
            if (result !== true) {
                const subject = courseYear.CourseYearSubjects.find(e => e.SubjectId === result.SubjectId);
                if (subject) {
                    if (subject.IsActive) {
                        this.sweetAlertService.info('Info', 'Ya existe la materia en el año ' + courseYear.CourseYearName, null);
                    } else {
                        subject.IsActive = true;
                    }
                } else {
                    courseYear.CourseYearSubjects.push(result);
                }
            }
        });
    }

    editSubject(subject: SubjectDataDto) {
        const config: MatDialogConfig = {
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                subject: subject,
                subjects: this.subjects
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditSubjectCourseComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
        });
    }

    deleteSubject(subject: SubjectDataDto) {
        this.sweetAlertService.question(
            '',
            '¿Desea borrar la materia de este año?',
            'Aceptar',
            'Cancelar',
            () => {
                subject.IsActive = false;
            },
            () => {
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/curricula/add-edit-curriculum/add-edit-curriculum.component.ts